/* FREE VET CONSULT — page behaviour (templates/product.vet-consultation.json)
   Sticky CTA after the hero · How It Works cards fall into place · Dr Anna's
   photo tilts in · the review deck (spring-driven, swipe/flick/arrows/dots).
   Booking: every "Book your free consult" button presses the page's own
   Add to cart (a visually hidden copy of the theme's product form, in the
   hero section). Cowlendar hooks that button exactly as it does on the
   standard product page and opens its popup; nothing goes in the basket. */
(function(){
  if (window.__gcVetInit) return; window.__gcVetInit = true;   /* the script tag is in every section; run once */

  /* Booking — press the page's own Add to cart (the hidden product form in the hero section).
     Cowlendar is attached to that button, so this opens its booking popup just as clicking
     Add to cart on the standard product page does. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.js-gc-book'); if (!btn) return;
    e.preventDefault();
    var atc = document.querySelector('form.single-product-form .main-product__atc');
    if (atc) atc.click();
  });
  var hero = document.querySelector('.gc-hero');
  document.body.classList.add('gc-has-sticky');
  if (hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(entries){
      document.body.classList.toggle('gc-atc-on', !entries[0].isIntersecting);
    }, {rootMargin:'-80px 0px 0px 0px'}).observe(hero);
  }
  /* How-it-works cards: each card falls into place the first time it
     scrolls into view and then stays put. Cards arriving in the same
     moment (the desktop row) are staggered; stacked on mobile, each
     drops as you reach it. */
  /* Dr Anna's photo tilts into place once a third of it is on screen */
  var annaPhoto = document.querySelector('.gc-anna__photo');
  if (annaPhoto) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(en, io){ if (en[0].isIntersecting) { annaPhoto.classList.add('is-in'); io.disconnect(); } }, { threshold: .3 }).observe(annaPhoto);
    } else { annaPhoto.classList.add('is-in'); }
  }

  /* Dr Anna's video: plays muted (and loops) while at least half of it is on
     screen, pauses when it scrolls away. Hover, focus or a tap shows the
     controls: play/pause, scrub, sound, full screen. Turning sound on carries
     on from where it is (the captions are burned in, so nothing's missed), and
     with sound on it plays to the end once rather than looping.
     Reduced motion: it never starts by itself. */
  [].forEach.call(document.querySelectorAll('[data-gc-video]'), function (box) {
    var v = box.querySelector('video'); if (!v) return;
    var bPlay = box.querySelector('.gc-video__play'), bFs = box.querySelector('.gc-video__fs'),
        range = box.querySelector('.gc-video__range'), time = box.querySelector('.gc-video__time'),
        bSound = [].slice.call(box.querySelectorAll('.gc-video__sound'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var userPaused = !!reduce, inView = false, uiTimer;
    v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; v.controls = false;
    /* (Standalone preview only: the video is embedded in the file as data, which
       Safari won't play directly, so it's handed over as a blob. On the site the
       video comes from Shopify and this does nothing.) */
    var src = v.getAttribute('data-gc-src'), ready = Promise.resolve();
    if (src) ready = fetch(src).then(function(r){ return r.blob(); }).then(function(b){ v.src = URL.createObjectURL(b); }).catch(function(){ v.src = src; });
    function fmt(t){ t = Math.max(0, Math.floor(t || 0)); return Math.floor(t / 60) + ':' + ('0' + (t % 60)).slice(-2); }
    function sync(){
      box.classList.toggle('is-paused', v.paused);
      box.classList.toggle('is-muted', v.muted);
      box.classList.toggle('is-held', v.paused && (userPaused || v.ended));   /* stopped on purpose: keep the controls up */
      if (bPlay) bPlay.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
      bSound.forEach(function(b){ b.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off'); b.setAttribute('aria-pressed', v.muted ? 'false' : 'true'); });
    }
    function progress(){
      var d = v.duration || 0, p = d ? v.currentTime / d : 0;
      if (range && !range.matches(':active')) range.value = Math.round(p * 1000);
      box.style.setProperty('--gc-p', (p * 100).toFixed(2) + '%');
      if (time) time.textContent = fmt(v.currentTime) + ' / ' + fmt(d);
    }
    function play(){
      ready.then(function(){
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function(){ if (!v.muted) { v.muted = true; v.loop = true; sync(); v.play().catch(function(){}); } });
      });
    }
    ['play', 'pause', 'ended', 'volumechange'].forEach(function(e){ v.addEventListener(e, sync); });
    ['timeupdate', 'loadedmetadata', 'seeked'].forEach(function(e){ v.addEventListener(e, progress); });
    if (bPlay) bPlay.addEventListener('click', function(){
      if (v.paused) { userPaused = false; if (v.ended) v.currentTime = 0; play(); }
      else { userPaused = true; v.pause(); }
    });
    bSound.forEach(function(b){ b.addEventListener('click', function(){
      if (v.muted) {
        v.muted = false; v.loop = false; userPaused = false;   /* sound on from where it is */
        if (v.paused) play();
      } else { v.muted = true; v.loop = true; }
      sync();
    }); });
    if (range) range.addEventListener('input', function(){ if (v.duration) { v.currentTime = range.value / 1000 * v.duration; progress(); } });
    var canFs = v.requestFullscreen || v.webkitEnterFullscreen || v.webkitRequestFullscreen;
    if (bFs && !canFs) bFs.hidden = true;
    if (bFs) bFs.addEventListener('click', function(){
      if (v.requestFullscreen) v.requestFullscreen(); else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen(); else if (v.webkitRequestFullscreen) v.webkitRequestFullscreen();
    });
    document.addEventListener('fullscreenchange', function(){ v.controls = document.fullscreenElement === v; });
    /* touch: a tap on the video brings the controls up for a few seconds */
    box.addEventListener('pointerup', function(e){
      if (e.pointerType === 'mouse' || e.target.closest('button, input')) return;
      box.classList.add('is-ui'); clearTimeout(uiTimer);
      uiTimer = setTimeout(function(){ box.classList.remove('is-ui'); }, 3500);
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(en){
        var r = en[0].intersectionRatio;
        if (r >= .5) { inView = true; if (!userPaused && v.paused && !v.ended) play(); }
        else if (r < .25 && inView) { inView = false; if (!v.paused) v.pause(); }
      }, { threshold: [0, .25, .5] }).observe(box);
    }
    sync(); progress();
  });

  var steps = [].slice.call(document.querySelectorAll('.gc-how .gc-step'));
  if (steps.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        var fresh = entries.filter(function(e){ return e.isIntersecting && !e.target.classList.contains('is-in'); })
                           .sort(function(a, b){ return steps.indexOf(a.target) - steps.indexOf(b.target); });
        fresh.forEach(function(e, k){ e.target.style.setProperty('--d', (k * .18).toFixed(2) + 's'); e.target.classList.add('is-in'); io.unobserve(e.target); });
      }, { threshold: .35 });            /* a third of the card showing before it drops */
      steps.forEach(function(s){ io.observe(s); });
    } else { steps.forEach(function(s){ s.classList.add('is-in'); }); }
  }

  /* Review deck — a physical stack driven by springs rather than CSS
     transitions: every card animates from where it is on screen, a card in
     flight can be grabbed and reversed at any moment, and a release hands the
     finger's velocity straight into the motion (no seam between drag and
     animation). Critically damped (no overshoot) at response 0.4s. */
  var rev = document.getElementById('gcReviews');
  if (rev) {
    var slides = [].slice.call(rev.querySelectorAll('.gc-rev__slide')),
        dots = [].slice.call(rev.querySelectorAll('.gc-rev__dots button')),
        n = slides.length, cur = 0,
        reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var natural = [];
    function measure(){ slides.forEach(function(s){ s.style.height = 'auto'; }); natural = slides.map(function(s){ return s.offsetHeight; }); }

    /* one Figma px in CSS px, read live from the stage */
    var probe = document.createElement('i');
    probe.style.cssText = 'position:absolute;left:0;top:0;width:calc(var(--u) * 100);height:0;visibility:hidden;pointer-events:none';
    rev.appendChild(probe);
    function U(){ return probe.getBoundingClientRect().width / 100 || 1; }

    /* poses */
    var STACK = [{x:0,y:0,r:0,s:1},{x:10,y:14,r:3,s:.975},{x:-8,y:26,r:-2.5,s:.95},{x:6,y:36,r:1.5,s:.925}];
    function stackPose(pos){ var u = U(), q = STACK[Math.min(pos, 3)]; return { x: q.x * u, y: q.y * u, r: q.r, s: q.s }; }
    function outPose(dir){ var w = rev.offsetWidth, h = natural[cur] || rev.offsetHeight; return { x: dir * 0.36 * w, y: 0.18 * h, r: dir * 13, s: .96 }; }
    function posOf(k){ return (k - cur + n) % n; }

    /* per-card state: p = on-screen pose, v = velocity, t = target */
    var S = slides.map(function(el){ return { el: el, p: {x:0,y:0,r:0,s:1}, v: {x:0,y:0,r:0,s:0}, t: {x:0,y:0,r:0,s:1}, held: false, flight: null }; });
    function render(st){ st.el.style.transform = 'translate(' + st.p.x.toFixed(2) + 'px,' + st.p.y.toFixed(2) + 'px) rotate(' + st.p.r.toFixed(2) + 'deg) scale(' + st.p.s.toFixed(4) + ')'; }

    var OMEGA = 2 * Math.PI / 0.4, KEYS = ['x','y','r','s'];      /* response 0.4s */
    function step(st, dt){ var done = true;
      KEYS.forEach(function(k){ var p = st.p[k], v = st.v[k], t = st.t[k];
        v += (-OMEGA * OMEGA * (p - t) - 2 * OMEGA * v) * dt; p += v * dt;      /* damping ratio 1: settles, never overshoots */
        var tiny = k === 's' ? 0.0005 : 0.05, slow = k === 's' ? 0.005 : 0.5;
        if (Math.abs(v) > slow || Math.abs(p - t) > tiny) done = false; else { p = t; v = 0; }
        st.p[k] = p; st.v[k] = v; });
      return done; }
    var raf = null, last = 0;
    function tick(ts){ var dt = Math.min(0.032, ((ts - last) / 1000) || 0.016); last = ts; var active = false;
      S.forEach(function(st){
        if (st.held) { active = true; return; }
        var done = step(st, dt); render(st); if (!done) active = true;
        if (st.flight && st.flight.phase === 'out' && Math.abs(st.p.x) > 0.85 * Math.abs(st.flight.out.x)) toBack(st);   /* well on its way: drop behind the stack */
        if (st.flight && st.flight.phase === 'back' && done) { st.flight = null; layout(); } });
      raf = active ? requestAnimationFrame(tick) : null; }
    function wake(){ if (!raf) { last = performance.now(); raf = requestAnimationFrame(tick); } }
    function setTarget(st, pose){ st.t = pose;
      if (reduce) { st.p = { x: pose.x, y: pose.y, r: pose.r, s: pose.s }; st.v = {x:0,y:0,r:0,s:0}; render(st); } else wake(); }
    function toBack(st){ st.flight.phase = 'back'; st.el.style.zIndex = 0; setTarget(st, stackPose(posOf(S.indexOf(st)))); }

    function layout(){
      var h = natural[cur];
      rev.style.height = h + 'px';                               /* stage hugs the front card */
      S.forEach(function(st, k){ var pos = posOf(k);
        st.el.setAttribute('data-pos', Math.min(pos, 3)); st.el.setAttribute('aria-hidden', pos !== 0); st.el.style.height = h + 'px';
        if (!st.flight) { st.el.style.zIndex = n - pos; if (!st.held) setTarget(st, stackPose(pos)); } });
      dots.forEach(function(d, k){ d.classList.toggle('on', k === cur); });
    }
    /* the front card leaves in direction dir (-1 left, +1 right); `to` names the card that takes its place */
    function commit(dir, to, vel){
      var st = S[cur]; st.held = false; st.el.classList.remove('is-dragging');
      st.flight = { phase: 'out', out: outPose(dir) }; st.el.style.zIndex = n + 2;
      if (vel) { st.v.x = vel.x; st.v.y = vel.y; }                /* velocity handoff: the card keeps the finger's speed */
      setTarget(st, st.flight.out);
      cur = (to !== undefined) ? to : (cur - dir + n) % n;
      layout();
    }
    rev.querySelector('.gc-rev__arrow--prev').addEventListener('click', function(){ commit(+1); });
    rev.querySelector('.gc-rev__arrow--next').addEventListener('click', function(){ commit(-1); });
    dots.forEach(function(d){ d.addEventListener('click', function(){ var k = +d.getAttribute('data-i'); if (k !== cur) commit(-1, k); }); });

    /* drag — the front card, or any card still in flight (grab it and reverse) */
    var track = rev.querySelector('.gc-rev__track'), drag = null;
    track.addEventListener('pointerdown', function(e){ if (e.button) return;
      var el = e.target.closest && e.target.closest('.gc-rev__slide'); if (!el) return;
      var st = S[slides.indexOf(el)]; if (!(st === S[cur] || st.flight)) return;
      drag = { st: st, x: e.clientX, px: st.p.x, py: st.p.y, hist: [{ x: e.clientX, t: e.timeStamp }] };
      st.held = true; st.v = {x:0,y:0,r:0,s:0}; el.classList.add('is-dragging'); el.setPointerCapture && el.setPointerCapture(e.pointerId); });
    track.addEventListener('pointermove', function(e){ if (!drag) return; var st = drag.st, dx = e.clientX - drag.x;
      drag.hist.push({ x: e.clientX, t: e.timeStamp }); if (drag.hist.length > 6) drag.hist.shift();
      st.p.x = drag.px + dx; st.p.y = drag.py + Math.abs(dx) * 0.08; st.p.r = st.p.x / 18; render(st); });   /* 1:1 with the finger, from where it was grabbed */
    function endDrag(e){ if (!drag) return; var st = drag.st, h = drag.hist; drag = null;
      st.held = false; st.el.classList.remove('is-dragging');
      var old = h[0], v = (h.length > 1 && e.timeStamp > old.t) ? (e.clientX - old.x) / (e.timeStamp - old.t) * 1000 : 0;   /* px/s */
      /* project where it would coast to (scroll-style deceleration, d = .995) and decide from there */
      var end = st.p.x + v * 0.199, away = Math.abs(end) > 70, dir = end < 0 ? -1 : +1;
      if (Math.abs(v) > 300 && (v < 0) !== (st.p.x < 0)) away = false;        /* flicked back the other way: it returns */
      if (st === S[cur] && !st.flight) {
        if (away) commit(dir, undefined, { x: v, y: 0 }); else { st.v.x = v; setTarget(st, stackPose(0)); }
      } else {                                                                 /* a card caught mid-flight */
        if (away) { st.flight = { phase: 'out', out: outPose(dir) }; st.el.style.zIndex = n + 2; st.v.x = v; setTarget(st, st.flight.out); }
        else { st.flight = null; cur = S.indexOf(st); st.el.style.zIndex = n + 2; st.v.x = v; layout(); }   /* pulled back: it becomes the front again */
      } }
    track.addEventListener('pointerup', endDrag); track.addEventListener('pointercancel', endDrag);

    measure();
    S.forEach(function(st, k){ st.p = stackPose(posOf(k)); st.t = st.p; render(st); });   /* start in place, no entrance animation */
    layout();
    window.addEventListener('resize', function(){ measure(); layout(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ measure(); layout(); });
  }})();
